import { fdc } from "@/helpers/fabricadecodigo"
import axios from 'axios'

export const operacionesService = {
    obtenerData,
    obtenerVehiculos,
    obtenerEstacionamiento,
    obtenerSucursal,
    guardarTransaccion,
    obtenerTransaccion
}

function obtenerData()   {
    return new Promise((resolve, reject) => {
        axios.get(fdc.getHost("/operaciones/data"), fdc.getHeader()).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject({ resultado: "error", mensaje: "No fue posible obtener datos de operaciones", "status": error.response.status });
        });
    })
}

function obtenerVehiculos(id)   {
    return new Promise((resolve, reject) => {
        axios.get(fdc.getHost("/operacion/" + id), fdc.getHeader()).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject({ resultado: "error", mensaje: "No fue posible obtener datos de operaciones", "status": error.response.status });
        });
    })
}

function obtenerEstacionamiento()   {
    return new Promise((resolve, reject) => {
        axios.get(fdc.getHost("/datos/estacionamiento"), fdc.getHeader()).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject({ resultado: "error", mensaje: "No fue posible obtener datos de operaciones", "status": error.response.status });
        });
    })
}

function obtenerSucursal(id)   {
    return new Promise((resolve, reject) => {
        axios.get(fdc.getHost("/datos/estacionamiento/" + id), fdc.getHeader()).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject({ resultado: "error", mensaje: "No fue posible obtener datos de operaciones", "status": error.response.status });
        });
    })
}

function guardarTransaccion(request)    {
    return new Promise((resolve, reject) => {
        axios.post(fdc.getHost("/operacion/transaccion"), request, fdc.getHeader()).then((response) => {
            if (response.data.resultado == "ok")    {
                resolve(response.data)
            } else {
                reject(response.data)
            }
        }).catch((error) => {
            reject({ resultado: "error", mensaje: "No fue posible guardar la transacción", "status": error.response.status });
        })
    })
}

function obtenerTransaccion(idmovimiento)   {
    return new Promise((resolve, reject) => {
        axios.get(fdc.getHost("/operacion/transaccion/" + idmovimiento), fdc.getHeader()).then((response) => {
            if (response.data.resultado == "ok")    {
                resolve(response.data)
            } else {
                reject(response.data)
            }
        }).catch((error) => {
            reject({ resultado: "error", mensaje: "No fue posible obtener el movimiento", "status": error.response.status });
        })
    })
}

